import strings from 'utils/strings'
import { Panel } from '../Dash/Panels/Panels.style'
import { DASH_LABELS, DASH_TYPES } from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  F: {
    dependency: {
      panelNumber: 'A66-01975-000',
      top: 9,
      left: 10,
      width: 69,
      height: 117,
      zIndex: 5,
    },
  },
  Y: {
    dependency: {
      panelNumber: 'A66-01975-000',
      top: 9,
      left: 10,
      width: 69,
      height: 117,
      zIndex: 5,
    },
  },
  SSMSF: {
    partOverride: 'A06-90732-000',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  MST: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  MSF: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  HH: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
    hidePendingPill: true,
  },
  LSMST: {
    partOverride: 'A06-90731-000',
    preferLocationShape: true,
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  ICU: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: '43N_ICU_RHD',
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
  },
  // PBI 582715: keep the digital ICU visible and navigable on 43N RHD dashes.
  ICUC5: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: 'RHD Instrument Cluster Screen',
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
  },
  AUPNL: {
    partOverride: 'A22-74137-001',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    containedIn: 'AGFAC',
  },
  AGPNL: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: 'A22-75939-001',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  AGFAC: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: 'A22_73784_RHD',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  MS: {
    swapouts: {
      '06-95304-000': '06-95304-000_dashtype_003_002_43N',
    },
  },
}

export const DASH_META = {
  name: DASH_TYPES.DASH_43N_003_002,
  panels: ['AGFAC', 'ICU'],
  navPanels: ['AUPNL'],
  navOrder: ['AGFAC', 'AUPNL', 'ICU'],
  // PBI 479416: include room for the wider digital ICU beside AGFAC.
  width: 4400,
  height: 1100,
  panelsStyle: `
    & ${Panel}:nth-child(2){
      margin-left: 320px;
    }
  `,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  SS: 'Switch',
  A: 'Gauge',
  AC: 'Radio_CP001',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    ICU: {
      id: 'ICU',
      label: 'A Panel: ICU',
      groups: {},
    },
    AUPNL: {
      id: 'AUPNL',
      label: 'B Panel: Right Hand Aux',
      groups: {
        AU800: {
          order: 0,
          id: 'AU800',
          panel: 'AUPNL',
          label: 'MSF 8',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU700: {
          order: 1,
          id: 'AU700',
          panel: 'AUPNL',
          label: 'MSF 7',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU600: {
          order: 2,
          id: 'AU600',
          panel: 'AUPNL',
          label: 'MSF 6',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU500: {
          order: 3,
          id: 'AU500',
          panel: 'AUPNL',
          label: 'MSF 5',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU400: {
          order: 4,
          id: 'AU400',
          panel: 'AUPNL',
          label: 'MSF 4',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        AU300: {
          order: 5,
          id: 'AU300',
          panel: 'AUPNL',
          label: 'MSF 3',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['SS'],
        },
        au_gauges: {
          order: 6,
          id: 'au_gauges',
          panel: 'AUPNL',
          label: 'Aux Gauges',
          detail: ['A'],
        },
        au_other: {
          order: 7,
          id: 'au_other',
          panel: 'AUPNL',
          label: 'Aux Other',
          detail: [
            'E',
            'L',
            'D',
            'B',
            'H',
            'D-D',
            'S',
            'G',
            'T',
            'U',
            'A-A',
            'B-B',
          ],
        },
      },
    },
    AGFAC: {
      id: 'AGFAC',
      label: 'B Panel: Right Hand',
      groups: {
        LSMST: {
          order: 0,
          id: 'LSMST',
          panel: 'AGPNL',
          label: 'Right MSF',
          isMsfOrMst: true,
          detail: ['SS'],
          staticPart: {
            label: strings.hazard_lights,
            afterIndex: 4,
          },
        },
        CSMAN: {
          order: 1,
          id: 'CSMAN',
          panel: 'AGPNL',
          label: 'Center MSF',
          isMsfOrMst: true,
          detail: ['SS'],
        },
        RSMAN: {
          order: 2,
          id: 'RSMAN',
          panel: 'AGPNL',
          label: 'Left MSF',
          isMsfOrMst: true,
          detail: ['SS'], // should be JJ and locations should say JJ detail
        },
        LPMN1: {
          order: 3,
          id: 'LPMN1',
          panel: 'AGPNL',
          label: 'Lower MSF 1',
          isMsfOrMst: true,
          detail: ['SS'],
        },
        LPMN2: {
          order: 4,
          id: 'LPMN2',
          panel: 'AGPNL',
          label: 'Lower MSF 2',
          isMsfOrMst: true,
          detail: ['SS'],
        },
        switches: {
          order: 5,
          id: 'switches',
          panel: 'AGFAC',
          label: 'Lower Switches',
          detail: ['F'],
        },
        ag_gauges: {
          order: 6,
          id: 'gauges',
          panel: 'AGPNL',
          label: 'Gauges',
          detail: ['A'],
        },
        ag_other: {
          order: 7,
          id: 'other',
          panel: 'AGPNL',
          label: 'Other',
          detail: [
            'AC',
            'E',
            'L',
            'B',
            'H',
            'D-D',
            'S',
            'G',
            'T',
            'U',
            'A-A',
            'B-B',
            'PR',
            'X',
            'Y',
          ],
        },
      },
    },
  },
}
